import { CareType, PRAXIA_CARE_TYPES } from '@pflegia/types/api/employer/care-type';
import { JobPosition as PflegiaJobPosition } from '@pflegia/types/api/job-position/job-position';
import { ScrollableSectionEnum } from '@pflegia/types/common/enums/scrollable-section-enum';
import { buildSectionList } from '@pflegia/ui/shared/utils/layout.helper';

export const pflegiaSectionOrder = [
  ScrollableSectionEnum.Salary,
  ScrollableSectionEnum.Location,
  ScrollableSectionEnum.Career,
  ScrollableSectionEnum.ShiftSystem,
  ScrollableSectionEnum.Responsibilities,
  ScrollableSectionEnum.Profile,
  ScrollableSectionEnum.Summary,
  ScrollableSectionEnum.ContactPerson,
  ScrollableSectionEnum.AboutUs,
  ScrollableSectionEnum.ClientAssignment,
  ScrollableSectionEnum.Differentiations,
  ScrollableSectionEnum.OpeningHours,
  ScrollableSectionEnum.Benefits,
  ScrollableSectionEnum.Onboarding,
  ScrollableSectionEnum.Gallery,
  ScrollableSectionEnum.EmployeeTestimony,
  ScrollableSectionEnum.DailyWork,
  ScrollableSectionEnum.Insights,
];

export const getPflegiaSections = (jobPosition: PflegiaJobPosition) =>
  buildSectionList(
    jobPosition,
    position => ({
      [ScrollableSectionEnum.ClientAssignment]:
        position.employer.typesLeasingEmployer?.length > 0 && position.employer.careType === CareType.Leasing,
      [ScrollableSectionEnum.Differentiations]:
        position.employer.differentiations?.length > 0 && position.employer.careType === CareType.Leasing,
      [ScrollableSectionEnum.OpeningHours]:
        position.showOpeningHours && (position.openingHours ?? []).length > 0 && PRAXIA_CARE_TYPES.includes(position.employer.careType),
      [ScrollableSectionEnum.ShiftSystem]: position.shiftCount > 0,
      [ScrollableSectionEnum.DailyWork]: Boolean(position.whatADayLooksLike),
      [ScrollableSectionEnum.Insights]: Boolean(position.employer.youtubeVideoUrl),
      [ScrollableSectionEnum.ContactPerson]: true,
      [ScrollableSectionEnum.EmployeeTestimony]: Boolean(position.employer.testimonyQuote),
    }),
    {
      [ScrollableSectionEnum.Salary]: Boolean(jobPosition.employer?.showSalary && jobPosition.showSalary),
      [ScrollableSectionEnum.AboutUs]: Boolean(jobPosition.employer.aboutUs),
    },
    pflegiaSectionOrder,
  );
